/* 4U empty cart drawer: quick add on the suggestion cards in
   snippets/fu-cart-empty.liquid. Tap + to show sizes over the photo, tap a
   size to add it (one-size products add straight away). Uses the same cart
   flow as assets/fu-quick-add.js: add, then re-render the drawer through the
   theme's cart events so the free gift / upsell code keeps working.
   Click handling is delegated, so it keeps working after the drawer
   re-renders over AJAX. Loaded once by sections/cart-drawer.liquid. */
(function () {
  if (window.__fuCe) return;
  window.__fuCe = true;

  function bundled() {
    var s = [];
    try { document.documentElement.dispatchEvent(new CustomEvent('cart:bundled-sections', { bubbles: true, detail: { sections: s } })); } catch (e) {}
    return s.filter(function (x, i) { return x && s.indexOf(x) === i; });
  }
  function swapSections(sec) {
    if (!sec) return;
    Object.keys(sec).forEach(function (id) {
      if (!sec[id]) return;
      var doc = new DOMParser().parseFromString(sec[id], 'text/html');
      ['MiniCart-', 'MainCart-'].forEach(function (pre) {
        var cur = document.getElementById(pre + id), fresh = doc.getElementById(pre + id);
        if (cur && fresh) cur.innerHTML = fresh.innerHTML;
      });
    });
  }
  function add(id) {
    var body = { items: [{ id: Number(id), quantity: 1 }] };
    var sec = bundled();
    if (sec.length) {
      body.sections = sec;
      if (/^\//.test(window.location.pathname)) body.sections_url = window.location.pathname;
    }
    return fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify(body) })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw new Error(j.description || j.message || 'Could not add that size'); return j; }); })
      .then(function (j) {
        swapSections(j.sections);
        return fetch('/cart.js', { headers: { 'Accept': 'application/json' }, cache: 'no-store' }).then(function (r) { return r.json(); }).then(function (cart) {
          document.querySelectorAll('cart-count').forEach(function (c) { c.textContent = cart.item_count; if (cart.item_count > 0) c.removeAttribute('hidden'); else c.setAttribute('hidden', ''); });
          try { document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: cart } })); } catch (x) {}
          if (window.theme && theme.pubsub && theme.pubsub.publish && theme.pubsub.PUB_SUB_EVENTS) {
            try { theme.pubsub.publish(theme.pubsub.PUB_SUB_EVENTS.cartUpdate, { source: 'fu-cart-empty', cart: Object.assign({}, cart, { sections: j.sections || {} }) }); } catch (x) {}
          }
        });
      });
  }
  function close(card) {
    if (!card) return;
    card.classList.remove('is-picking');
    var p = card.querySelector('[data-fu-ce-sizes]');
    if (p) p.hidden = true;
    var b = card.querySelector('[data-fu-ce-open]');
    if (b) { b.setAttribute('aria-expanded', 'false'); }
  }
  function closeAll(except) {
    document.querySelectorAll('[data-fu-ce-card].is-picking').forEach(function (c) { if (c !== except) close(c); });
  }

  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;

    var open = t.closest('[data-fu-ce-open]');
    if (open) {
      e.preventDefault();
      var card = open.closest('[data-fu-ce-card]');
      closeAll(card);
      card.classList.add('is-picking');
      var panel = card.querySelector('[data-fu-ce-sizes]');
      if (panel) {
        panel.hidden = false;
        var first = panel.querySelector('.fu-ce__size:not([disabled])');
        if (first) { try { first.focus({ preventScroll: true }); } catch (x) {} }
      }
      open.setAttribute('aria-expanded', 'true');
      return;
    }

    var x = t.closest('[data-fu-ce-close]');
    if (x) { e.preventDefault(); close(x.closest('[data-fu-ce-card]')); return; }

    var btn = t.closest('[data-fu-ce-add]');
    if (btn && btn.closest('.fu-ce')) {
      e.preventDefault();
      if (btn.disabled || btn.classList.contains('is-busy')) return;
      var c = btn.closest('[data-fu-ce-card]');
      var err = c && c.querySelector('.fu-ce__err');
      if (err) err.textContent = '';
      btn.classList.add('is-busy');
      add(btn.getAttribute('data-fu-ce-add')).then(function () {
        btn.classList.remove('is-busy');
        btn.classList.add('is-done');
      }).catch(function (er) {
        btn.classList.remove('is-busy');
        if (err) err.textContent = (er && er.message) || 'Could not add, please try again.';
        else if (window.console) console.warn('[4U empty cart]', er);
      });
      return;
    }

    if (!t.closest('[data-fu-ce-card].is-picking')) closeAll(null);
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeAll(null);
  });
})();
